import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    Box,
    IconButton,
    useMediaQuery,
    useTheme
} from '@mui/material';
import bannerImage from '../../src/images/IMG_1736.png'

const SlidingBanner = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const banners = [
        {
            id: 1,
            imageUrl: "https://s3.ap-southeast-1.amazonaws.com/boatrental.trueleasing.co.th/shareticket/Banner+Join+Trip%402x.png",
            altText: "โปรโมชั่นพิเศษ",
            path: ''
        },
        // {
        //     id: 2,
        //     imageUrl: "https://d1aeyn46ohn8t4.cloudfront.net/eyJidWNrZXQiOiJjbXMucHJvZC50cnVlLWxlYXNpbmciLCJrZXkiOiJ0cnVlLWxlYXNpbmcvdjEvbWVkaWEvMTY3MzMyMzM2MzkyMCIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwMCwid2l0aG91dEVubGFyZ2VtZW50Ijp0cnVlfX19",
        //     altText: "สินค้าใหม่",
        //     path: 'https://trueleasing.co.th/th/pages/Promotionboat202440'
        // },
        // {
        //     id: 3,
        //     imageUrl: "https://d1aeyn46ohn8t4.cloudfront.net/eyJidWNrZXQiOiJjbXMucHJvZC50cnVlLWxlYXNpbmciLCJrZXkiOiJ0cnVlLWxlYXNpbmcvdjEvbWVkaWEvMTcyNjgyNTQ3ODcyNyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwMCwid2l0aG91dEVubGFyZ2VtZW50Ijp0cnVlfX19",
        //     altText: "ส่งฟรี",
        //     path: 'https://trueleasing.co.th/th/pages/ayutthayabranch'
        // }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % banners.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [banners.length]);

    const handleNavigation = (direction) => {
        setCurrentSlide((prev) =>
            direction === 'next' ? (prev + 1) % banners.length : (prev - 1 + banners.length) % banners.length
        );
    };

    const buttonStyles = {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        bgcolor: 'rgba(255, 255, 255, 0.3)',
        color: 'white',
        zIndex: 2,
        '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' },
    };

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                // maxHeight:'420px',
                overflow: 'hidden',
                // margin:'px',
                marginBottom: 0,
                backgroundColor: theme.palette.background.paper,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    transition: 'transform 500ms ease',
                    transform: `translateX(-${currentSlide * 100}%)`,
                }}
            >
                {banners.map((banner) => (
                    <Box
                        key={banner.id}
                        // component={Link}
                        // to={banner.path}
                        sx={{
                            flexShrink: 0,
                            width: '100%',

                            textDecoration: 'none',
                        }}
                       
                    >
                        <Box
                            component="img"
                            src={banner.imageUrl}
                            alt={banner.altText}
                            
                            sx={{
                                width: '100%',
                                marginBottom: "-10px" ,
                                height:'100%',
                                // maxHeight:'420px',
                                objectFit: 'fill',
                                objectPosition: 'center',
                            }}
                        />
                    </Box>
                ))}
            </Box>

            {!isMobile && banners.length > 1 && (
                <>
                    <IconButton
                        onClick={(e) => { e.preventDefault(); handleNavigation('prev'); }}
                        sx={{ ...buttonStyles, left: { xs: 1, sm: 2 } }}
                    >
                        {/* <ChevronLeft /> */}
                    </IconButton>
                    <IconButton
                        onClick={(e) => { e.preventDefault(); handleNavigation('next'); }}
                        sx={{ ...buttonStyles, right: { xs: 1, sm: 2 } }}
                    >
                        {/* <ChevronRight /> */}
                    </IconButton>
                </>
            )}

            {
                banners.length > 1 && (
                    <Box
                        sx={{
                            position: 'absolute',
                            // marginTop:'-px',
                            bottom: { xs: 1, sm: 2 },
                            left: '50%',
                            transform: 'translateX(-50%)',
                            display: 'flex',
                            gap: { xs: 0.5, sm: 1 },
                            zIndex: 2,
                        }}
                    >
                        {banners.map((_, index) => (
                            <Box
                                key={index}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setCurrentSlide(index);
                                }}
                                sx={{
                                    width: { xs: 8, sm: 12 },
                                    height: { xs: 8, sm: 12 },
                                    borderRadius: '50%',
                                    bgcolor: currentSlide === index ? 'white' : 'rgba(255, 255, 255, 0.5)',
                                    cursor: 'pointer',
                                    transition: 'background-color 200ms',
                                    marginBottom: '10px'
                                }}
                            />
                        ))}
                    </Box>
                )
            }
        </Box>
    );
};

export default SlidingBanner;
